export const PROVIDER_CODE = {
  roaming: 'NTT001', // 로밍망
  local: 'NTT002' // 로컬망
} as const

export const COUPON_DC_CODE = {
  won: 'DCT001', // codeName: 원
  percent: 'DCT002' // codeName: %
} as const

export const COUPON_CODE = {
  issue: 'CPT001', // 발급쿠폰
  product: 'CPT002', // 상품쿠폰
  won: 'CPT003', // 원쿠폰
  exchange: 'CPT004', // 교환쿠폰
  voucher: 'CPT005', // 교환권
  freeShippingFee: 'CPT006'
} as const

export const OPTION_CODE = {
  all: 'CPO001', // 모두(로밍+로컬)
  roaming: 'CPO002', // 로밍
  local: 'CPO003' // 로컬
} as const

export const DELIVERY_TYPE = {
  ROCKET: 'dhero', // 당일 배송
  STANDARD: 'postoffice' // 일반 배송
} as const

export const ENTRY_METHOD = {
  password: 'PASSWORD', // 공동현관 비밀번호
  free: 'FREE', // 자율출입 가능
  etc: 'ETC' // 기타
} as const

export const PG_TYPE = {
  NONE: 'NONE',
  PORTONE: 'PORTONE',
  TOSS: 'TOSS',
  NPAY: 'NPAY'
} as const

// 세션스토리지 저장 상수
export const ORDER_REDIRECT_URL = 'orderRedirectUrl'
export const ALLOW_ORDER_SUCCESS = 'allow-order-success'
export const ORDER_APPROVE_KEY_PREFIX = 'order-approve'

// 적립금 오류 메시지
export const POINT_ERROR_MSG = {
  PURCHASE: '적립금은 1,000원 이상부터 사용 가능해요.',
  INPUT: '1,000원 이상 사용 가능해요.',
  EXCEED: '보유 금액 이상 사용은 불가능해요.',
  RESET: '쿠폰 적용으로 적립금 사용이\n해제됐어요. 다시 선택해 주세요.'
} as const
